import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'course-authoring.course-outline.empty-placeholder.title',
    defaultMessage: 'You haven\'t added any content to this course yet.',
  },
});

export default messages;
